import { PaginationBar } from "@components/PaginationBar";
import { ItemCardV2 } from "@components/item/ItemCardV2";
import { useApi } from "@hooks/ApiHook";
import { CollectionResponse } from "baaanggg";
import React, { useState } from "react";

export interface Props {
    collection: CollectionResponse
}

export default function ItemTab({ collection }: Props) {
    const [showSoldOut, setShowSoldOut] = useState(false)
    const [page, setPage] = useState(1)
    const [search, setSearch] = useState("")
    const { data: paginatedItems } = useApi(api => api.item.all({ collectionId: collection.id, page, search, includeSoldOutItem: showSoldOut }), [collection, page, search, showSoldOut])

    let debounceTimer: NodeJS.Timeout;
    const onSearch = (text: string) => {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(() => setSearch(text), 500);
    };

    return <div>
        <div className="mb-10 flex items-center">
            <div className="relative mr-2.5">
                <input
                    onChange={({ target }) => onSearch(target.value)}
                    type="search"
                    className="w-full rounded-lg border border-jacarta-100 py-[0.5rem] px-4 pl-10 text-jacarta-700 placeholder-jacarta-500 focus:ring-accent dark:border-gray-400 dark:bg-gray-900 dark:text-white dark:placeholder-white"
                    placeholder="Search" />
                <span className="absolute left-0 top-0 flex h-full w-12 items-center justify-center rounded-2xl">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"
                        className="h-4 w-4 fill-jacarta-500 dark:fill-white">
                        <path fill="none" d="M0 0h24v24H0z" />
                        <path
                            d="M18.031 16.617l4.283 4.282-1.415 1.415-4.282-4.283A8.96 8.96 0 0 1 11 20c-4.968 0-9-4.032-9-9s4.032-9 9-9 9 4.032 9 9a8.96 8.96 0 0 1-1.969 5.617zm-2.006-.742A6.977 6.977 0 0 0 18 11c0-3.868-3.133-7-7-7-3.868 0-7 3.132-7 7 0 3.867 3.132 7 7 7a6.977 6.977 0 0 0 4.875-1.975l.15-.15z" />
                    </svg>
                </span>
            </div>

            <button
                onClick={() => setShowSoldOut(prev => !prev)}
                className={`dropdown-toggle h-10 group group flex items-center rounded-lg border border-jacarta-100 bg-white px-4 font-display text-sm font-semibold text-jacarta-700 transition-colors hover:border-transparent hover:bg-accent hover:text-white ${showSoldOut ? "dark:border-transparent dark:bg-jacarta-500" : 'dark:border-gray-400 dark:bg-gray-900'} dark:text-white`}
                id="categoriesFilter" data-bs-toggle="dropdown" aria-expanded="false">
                <span>Show Sold Out Item</span>
            </button>
        </div>


        <div className="grid grid-cols-1 gap-[1.875rem] md:grid-cols-3 lg:grid-cols-4">
            {
                paginatedItems?.data.map(item => <ItemCardV2 key={item.id} item={item} />)
            }
        </div>

        <div className="mt-5"></div>

        {
            paginatedItems && <PaginationBar
                pagination={paginatedItems}
                currentPage={page}
                onPageChange={page => setPage(page)} />
        }
    </div>
}